import { ListViewFilter } from '@crm/api'
import { FieldType } from '@crm/types'
import { getAPIDateFormat } from '@crm/utils'
import { DefaultOptionType } from 'antd/es/select'

export const fieldTypeMap: Record<
  string,
  (value: ListViewFilter['value']) => ListViewFilter['value']
> = {
  [FieldType.DATE]: (value: ListViewFilter['value']) =>
    Array.isArray(value) ? value.map(getAPIDateFormat) : value,
  [FieldType.DATE_TIME]: (value: ListViewFilter['value']) =>
    Array.isArray(value) ? value.map(getAPIDateFormat) : value
}

export const listTransformKeyToString = (
  results: Record<string, any>[]
): DefaultOptionType[] => {
  return results?.map(({ key, label }) => ({
    value: key.toString(),
    label: label || '---'
  }))
}
